import { Badge } from '../../../../../../components/atoms/badge/badge';

interface Props {
  upsell: boolean;
}

export const VendaUpsellBadge = ({ upsell }: Props) => {
  if (!upsell) return null;
  return <Badge variant="info">Upsell</Badge>;
};
